import { Icon } from "@iconify/react";

export const leaderboard = [
  {
    department: "Operations",
    employee: "Martha Grey",
    status: "Present",
    button: "see more",
    icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  },
  {
    department: "Human resources",
    employee: "James Brown",
    status: "Absent",
    button: "see more",
    icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  },
  {
    department: "Marketing",
    employee: "Aisha Davis",
    status: "Present",
    button: "see more",
    icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  },
  {
    department: "Technology",
    employee: "Peter Walker",
    status: "Present",
    button: "see more",
    icon: <Icon icon="eva:arrow-ios-back-fill" rotate={2} />,
  },
];
